var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"relative",attrs:{"id":"app"}},[(_vm.tempPopup)?_c('div',{staticClass:"temp_popup"},[_c('div',{staticClass:"temp_popup_inner"},[_c('img',{attrs:{"src":require("@/assets/images/temp_pop.png"),"alt":"임시 팝업"}}),_c('div',{staticClass:"temp_popup_btn_wrap"},[_c('button',{staticClass:"forever_nonview",on:{"click":_vm.hideForever}}),_c('button',{staticClass:"check_confirm",on:{"click":_vm.hideOne}})])])]):_vm._e(),_c('Notice'),(_vm.isLoading)?_c('div',{staticClass:"spinnerWrapper"},[_c('Spinner',{attrs:{"active":_vm.isLoading,"loader":"dots","color":"#007FA2","background-color":"#000","opacity":0.5,"is-full-page":true}})],1):_vm._e(),(
      !(
        _vm.$route.path.includes('/qrcode') || _vm.$route.path.includes('/payment')
      ) &&
      (_vm.isPc ||
        !(_vm.$route.path.includes('/login') || _vm.$route.path.includes('/join')))
    )?_c('Header',{attrs:{"is-search":this.isSearch}}):_vm._e(),_c('router-view'),(
      !(
        _vm.$route.path.includes('/qrcode') || _vm.$route.path.includes('/payment')
      ) &&
      (_vm.isPc ||
        !(_vm.$route.path.includes('/login') || _vm.$route.path.includes('/join')))
    )?_c('Footer'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }